import { createContext, useContext } from "react";

const fallback = {
  admin: null,
  setAdmin: () => {},
  adminAuthChecked: true,
  login: async () => false,
  logout: async () => {},
  refresh: async () => null,
};

const AdminAuthContext = createContext(fallback);

export const useAdminAuth = () => useContext(AdminAuthContext) || fallback;

/** Public builds do not contact /authadmin. */
export default function AdminAuthProvider({ children }) {
  return children;
}
